import { getKeyDisplay } from "./formatKeyCombination.ts";
import type { KeyCombination } from "./types.ts";

/**
 * Generates a unique, deterministic identifier for a key combination.
 * Format: `[Ctrl+][Shift+][Alt+][Meta+]<keyCap>`
 *
 * The identifier uses the key cap (layout-independent) and maintains
 * a consistent modifier order for reliable comparison and storage.
 *
 */
export const getKeyCombinationIdentifier = (combination: KeyCombination) => {
  const parts: string[] = [];

  if (combination.ctrlKey) parts.push("Ctrl");
  if (combination.shiftKey) parts.push("Shift");
  if (combination.altKey) parts.push("Alt");
  if (combination.metaKey) parts.push("Meta");

  parts.push(getKeyDisplay(combination));

  return parts.join("+");
};
